<div class="land">

  <div class="navigation">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-md-4">
          <!-- <span class="logo"></span> -->
          <a rel="canonical" routerLink="/">
            <img class="buk-logo" src="/assets/logo-a.png" alt="">
          </a>
        </div>
      
        <div class="col col-md-4 text-right">
          <ul class="navlinks hidden-mobile">
            <li>
              <button rel="canonical" routerLink="/signup" class="btn btn-md btn-primary">{{ 'GENERAL.signupCta' | translate }}</button>
            </li>
          </ul>
          <ul class="navlinks visible-mobile">
            <!-- <li>
                    <a routerLink="/login">Login</a>
                  </li> -->
            <li>
              <button rel="canonical" routerLink="/signup" class="btn btn-md btn-primary">{{ 'GENERAL.signupCta' | translate }}</button>
            </li>
          </ul>
        </div>
      
      </div>
    </div>
  </div>

    <div class="section-1">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            
            <div class="text-center">
              <h2 class="title">{{ 'LANDING.faqs.title' | translate }}</h2>
            </div>

            <accordion [closeOthers]="true">
              <accordion-group heading="{{ 'LANDING.faqs.q' + faq | translate }}" *ngFor="let faq of faqsCount">
                <div [innerHTML]="'LANDING.faqs.a' + faq | translate"></div>
              </accordion-group>
            </accordion>
          
          </div>
        </div>
      </div>
    </div>
          
</div>